import React, {FC} from "react";
import styled from "@emotion/styled";
import {Button, Input} from "antd";

/**
 * Created by Tiger on 09/06/2022.
 */

export const Image = styled.img`
  height: 80px;
  width: 80px;
`

export const PrimaryButton = styled(Button)`
  width: 100%;
  height: 50px;
  border-radius: 30px;
`

export const SecondaryButton = styled(Button)`
  width: 100%;
  height: 50px;
  border-radius: 30px;
  border-color: #007AFF;
  color: #007AFF;
`

export const HCenter = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0 40px;
`
export const CenterColumn = styled(Column)`
  align-items: center;
`

export const Center = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const PlusImage = () => {
  return <Image style={{width:50, height:50}} src={require('../../../assets/login/mobile/qingping_plus@2x.png')}/>
}
export const GoogleImage = () => {
  return <Image style={{width:50, height:50}} src={require('../../../assets/login/mobile/google@2x.png')}/>
}


